let UTILS = require("../libs/utils.js");
var v7745;
var v7746;
module.exports = {
  id: "shrp",
  name: "Sharp Shooter",
  alias: "shrp",
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
  leaderStats: ["score", "kills", "deaths"],
  objWep: true,
  randClassScr: 0.5,
  gameStart: function (p9209) {
    p9209.activeObjective = 0;
    p9209.nextWeapon(null, true);
  },
  onKill: function (game, p9211, p9212, p9213) {
    if (p9213 && p9213 != p9212) {
      if (p9213.killStreak % 2 == 0) {
        game.players.giveEffect(p9213, 1);
      }
      if (p9213.killStreak % 3 == 0) {
        game.players.giveEffect(p9213, 2);
      }
      if (p9213.killStreak % 5 == 0) {
        game.players.giveEffect(p9213, 0);
      }
    }
  },
  forceClass: 9,
  disabledStreaks: [4, 5, 6]
};